<div class="bus-form-container">
    <div class="select-container">
        <mat-label>{{'routeForm.itinerary' | transloco}}</mat-label>
        <mat-form-field>
            <mat-select [value]="itineraryType()" (valueChange)="itineraryType.set($event)" name="itineraryType">
                <mat-option *ngFor="let itType of itineraryTypeOptions" [value]="itType">
                  {{(itType.label) | transloco}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    
    <div class="select-container">
        <mat-label>{{( combinedWith === 'walk' ? 'routeForm.maxWalkTime' : 'routeForm.maxBicycleTime') | transloco}}</mat-label>
        <mat-form-field>
            <mat-select [value]="maxWalkTime()" (valueChange)="maxWalkTime.set($event)" name="maxWalkTime">
                <mat-option *ngFor="let maxWT of maxWalkTimeOptions" [value]="maxWT">
                {{maxWT}} {{'routeForm.minutes' | transloco}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="select-container">
        <mat-label>{{ (combinedWith === 'walk' ? 'routeForm.yourStepWillBe' : 'routeForm.yourSpeedWillBe')  | transloco}}</mat-label>
        <mat-form-field> 
            <mat-select [value]="walkSpeed()" (valueChange)="walkSpeed.set($event)" name="walkSpeed">
                <mat-option *ngFor="let wSpeed of walkSpeedOptions" [value]="wSpeed">
                {{(wSpeed.label) | transloco}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    
    <div *ngIf="combinedWith==='walk' && wheelchairAccessible" class="check-container">
        <mat-checkbox [checked]="wheelchairAccessible()" (change)="wheelchairAccessible.set($event.checked)" color="primary"></mat-checkbox>
        <mat-label>{{'routeForm.wheelchairAccessibleRoute' | transloco}}</mat-label>
    </div>

</div>